// External libraries
import React from 'react';

// Internal modules
import {
  GuestSubmitButton,
  HiddenSubmitButton,
  SignupSubmitButton,
} from './Components';
import { CI, features } from '@/lib';
import { useStoreState } from '@/store';
import { Button } from '@/components/Button';
// @ts-expect-error untyped import
import { DisclosureArea } from '@/components/Form/Components';
import { POMAHeader } from '@/components/PasswordlessOnboarding/Components';

export const PasswordlessOptionalSignupSubmission = (): JSX.Element => {
  return (
    <>
      <POMAHeader />
      <DisclosureArea />
      <SignupSubmitButton />
      <GuestSubmitButton />
      <HiddenSubmitButton />
    </>
  );
};

interface PasswordlessForcedSignupSubmissionProps {
  showHeader?: boolean;
}

export const PasswordlessForcedSignupSubmission = ({
  showHeader = true,
}: PasswordlessForcedSignupSubmissionProps): JSX.Element => {
  return (
    <>
      {showHeader && <POMAHeader />}
      <SignupSubmitButton type="submit" />
    </>
  );
};

export const GenericSubmission = (): JSX.Element => {
  const onboardType = useStoreState(({ form }) => form.onboardOption.value);
  const interactionType =
    onboardType === 'signup'
      ? CI.Event.CREATE_ACCOUNT_AND_PAY_SUBMIT
      : CI.Event.GUEST_PAY_SUBMIT;

  const showDisclosures = features.allNotActive(
    'isWpsGuestUpgradeEligible',
    'isForcedGuest',
  );
  return (
    <>
      {showDisclosures && <DisclosureArea />}
      <Button
        customerInteraction={interactionType}
        testID="submit-button"
        isFormSubmission={false}
      />
    </>
  );
};
